<template>
    <div ref="rootElem">
        <slot/>
    </div>
</template>

<script>
import {ref, onMounted, getCurrentInstance} from "vue";


import {
    transitionClassesOpen,
    transitionClassesClose,
    calcBreakpoints,
    isTouchDevice,
    breakpointState
} from "@/utils";

export default {
    name: "main-navigation",
    props: {
        toggleDesktopNav: Function
    },

    setup(props, { emit }) {

        const rootElem = ref();
        const flyOutNavigation = ref();
        const lastElementClick = ref(null);
        const { root } = getCurrentInstance();

        const toggleDesktopNav = (state) => {
            props.toggleDesktopNav(state);
        };

        const initMobileNavigation = (mainMenu) => {
            if (mainMenu.length > 0) {
                let toggle = document.querySelector(".page-header__nav .page-header__toggle");
                toggle.classList.remove('hide');
            }
            for (let item of mainMenu) {
                let link = item.querySelector("a.has-subpages");
                if (link) {
                    link.addEventListener("click", e => {
                        if (
                            breakpointState.value.cur === 'tablet_portrait' ||
                            breakpointState.value.cur === 'mobile'
                        ) {
                            e.preventDefault();
                            const id = link.dataset.id;
                            let currentMobileMenu = rootElem.value.querySelector(
                                '.hide-mobile-right[data-id="' + id + '"]'
                            );
                            currentMobileMenu.classList.remove('hide-mobile-right');
                            currentMobileMenu.classList.add('current-mobile-menu');
                        }
                    });
                }

                // 'landingpage' mobile menu behaves different (pure anchor links)
                if (document.querySelector('body.pagets__Landingpage')) {
                    let link = item.querySelector("a");
                    if (link) {
                        link.addEventListener("click", e => {
                            root.setupState.toggleMobileNav(false);
                        });
                    }
                }

                let subNav = item.querySelectorAll("ul");
                if (
                    subNav[0] !== undefined &&
                    subNav[0].children !== undefined &&
                    subNav[0].children.length > 0
                ) {
                    initMobileNavigation(subNav[0].children);
                }
            }
        };

        window.addEventListener("click", () => {
            lastElementClick.value = null;
        })

        const initNavigationLayer = (mainMenu) => {
            flyOutNavigation.value = document.querySelector('#flyOutNavigation');
            const flyOutScroll = document.querySelector('.page-header__flyout--scroll');
            const closeButton = flyOutNavigation.value.querySelector(".page-header .button-close span");
            const overlay = document.querySelector('.overlay');

            [overlay, closeButton].forEach((el) => {
                el.addEventListener("click", e => {
                    e.preventDefault();
                    const item = rootElem.value.querySelector('.clicked');

                    if(item){
                        closeLayer(item);
                    }
                    toggleDesktopNav(false);
                });
            });

            for (let item of mainMenu) {

                let subNav = item.querySelector("ul");

                if (
                    subNav !== null &&
                    subNav.children !== undefined &&
                    subNav.children.length > 0
                ) {
                    let flyOutWrapper = document.createElement("div");
                    flyOutWrapper.classList.add("page-header__flyout--wrapper");
                    flyOutWrapper.dataset.trigger = item.id;

                    let flyOut = document.createElement("div");
                    flyOut.classList.add("page-header__flyout--inner");

                    let elementWrapper = document.createElement("div");
                    elementWrapper.classList.add("element");

                    let copy = subNav.cloneNode(true);
                    let chunks = Array.from(copy.children);

                    let subList = document.createElement("ul");
                    for (let i = 0; i < chunks.length; i++) {

                        if(chunks[i].dataset.break === "break") {
                            elementWrapper.appendChild(subList);
                            subList = document.createElement("ul");
                        }
                        subList.appendChild(chunks[i]);
                    }
                    elementWrapper.appendChild(subList);

                    flyOut.appendChild(elementWrapper);
                    flyOutWrapper.appendChild(flyOut);
                    flyOutScroll.appendChild(flyOutWrapper);

                    item.addEventListener("click", (e) => {
                        // only show layer navigation, if screens larger or equal to tablet landscape
                        if (
                            breakpointState.value.cur === 'tablet_landscape' ||
                            breakpointState.value.cur === 'desktop'
                        ) {
                            e.preventDefault();
                            let openedElement = rootElem.value.querySelector('.clicked');
                            if (openedElement === item) {
                                closeLayer(item);
                            } else if (openedElement !== null) {
                                changeLayer(openedElement, item);
                                setTitel(item);
                            } else {
                                openLayer(item);
                                setTitel(item);
                            }
                        }
                    });

                    item.addEventListener("click", (e) => {
                        if (
                            isTouchDevice() &&
                            breakpointState.value.down.indexOf("tablet_portrait") !== -1 &&
                            lastElementClick.value !== item
                        ){
                            e.preventDefault();
                            e.stopPropagation();
                            lastElementClick.value = item;
                        }
                    });

                }
            }

        };
        const setTitel = (item) => {
            let linkElement = item.querySelector("a");
            let title = linkElement.childNodes[0].textContent.trim();
            let link = linkElement.href;

            const overviewLink = document.querySelector(".page-header__overview-link");
            overviewLink.href = link;
            overviewLink.querySelector(".overview-link-variable").innerText = title;
        }
        const openLayer = (item) => {
            if (item.id !== undefined) {
                rootElem.value.querySelector("#" + item.id).classList.add("clicked");
                const flyOut = flyOutNavigation.value.querySelector(
                    '[data-trigger="' + item.id + '"]'
                );
                flyOut.classList.add("opened");
                toggleDesktopNav(false);
                document.getElementById('website-doehler').classList.add('flyout-open');
                setTimeout(() => {
                    transitionClassesOpen({
                        el: flyOutNavigation.value,
                        dropDown: flyOutNavigation.value,
                        height: flyOut.offsetHeight
                    })
                },2)

            }
        };
        const changeLayer = (oldItem, newItem) => {
            rootElem.value.querySelector("#" + oldItem.id).classList.remove("clicked");
            rootElem.value.querySelector("#" + newItem.id).classList.add("clicked");

            const newFlyOut = flyOutNavigation.value.querySelector(
                '[data-trigger="' + newItem.id + '"]'
            );
            const oldFlyOut = flyOutNavigation.value.querySelector(
                '[data-trigger="' + oldItem.id + '"]'
            );
            toggleDesktopNav(false);
            document.getElementById('website-doehler').classList.add('flyout-open');
            oldFlyOut.classList.remove("opened");
            newFlyOut.classList.add("opened");

        }
        const closeLayer = (item) => {
            if (item.id !== undefined) {
                const flyOut = flyOutNavigation.value.querySelector(
                    '[data-trigger="' + item.id + '"]'
                );
                let h = flyOut.offsetHeight;
                const cL = flyOut.classList;
                if (cL.contains("open") || cL.contains("opened")) {

                    rootElem.value.querySelector("#" + item.id).classList.remove("clicked");
                    flyOut.classList.remove("opened");
                    document.getElementById('website-doehler').classList.remove('flyout-open');

                    transitionClassesClose({
                        el: flyOutNavigation.value,
                        dropDown: flyOutNavigation.value,
                        height: h
                    })
                }
            }
        };
        const calculateVisibleMenuItems = () => {

            const mainMenu = rootElem.value.querySelector(".main-menu");
            const header = document.querySelector(".page-header__inner");
            const logo = document.querySelector(".page-header__logo");
            const toggle = document.querySelector(".page-header__panel-desktop");

            let hiddenItems = rootElem.value.querySelectorAll("li.hide");
            if(breakpointState.value.cur === ''){
                calcBreakpoints();
            }
            if (breakpointState.value.cur === 'tablet_portrait' ||
                breakpointState.value.cur === 'mobile') {
                for (let item of hiddenItems) {
                    item.classList.remove("hide");
                }
                return;
            }
            let hiddenCount = hiddenItems.length;
            if (hiddenCount !== 0){
                toggle.classList.remove("hide");
            }
            let maxMenuWidthNoToggle = header.getBoundingClientRect().width - logo.getBoundingClientRect().width;
            const menuItems = mainMenu.children;
            let itemWidth = 0;

            if (menuItems.length === 0){
                return;
            }

            for (let item of menuItems) {
                if(hiddenCount !== 0){
                    for (let item of hiddenItems) {
                        item.classList.remove("hide");
                    }
                }
                itemWidth += item.getBoundingClientRect().width;
            }
            if(itemWidth <= maxMenuWidthNoToggle && itemWidth !== 0){
                if(hiddenCount !== 0){
                    for (let item of hiddenItems) {
                        const id = item.dataset.nid;
                        const flyoutItem = document.querySelector(`[data-flyid="${id}"]`);
                        item.classList.remove("hide");
                        flyoutItem.classList.add("hide");
                    }
                }
                toggle.classList.add("hide");
                return;
            }
            itemWidth = 0;
            let sortedMenuItems = Array.from(menuItems)
                .map((el, index) => ({
                    el,
                    index,
                    hasPrio: el.dataset.priopage !== undefined
                }))
                .sort((a, b) => {
                    if (a.hasPrio && !b.hasPrio) return -1;
                    if (!a.hasPrio && b.hasPrio) return 1;
                    return a.index - b.index;
                })
                .map((item) => item.el);
            toggle.classList.remove("hide");
            let maxMenuWidthToggle = header.getBoundingClientRect().width - logo.getBoundingClientRect().width - toggle.getBoundingClientRect().width;
            for (let item of sortedMenuItems) {
                const id = item.dataset.nid;
                const flyoutItem = document.querySelector(`[data-flyid="${id}"]`);

                const hiddenItem = item.classList.contains('hide');
                if (hiddenItem) {
                    item.classList.remove("hide");
                    flyoutItem.classList.add("hide");
                }
                itemWidth += item.getBoundingClientRect().width;

                if(itemWidth >= maxMenuWidthToggle){
                    item.classList.add("hide");
                    flyoutItem.classList.remove("hide");
                }
                else{
                    flyoutItem.classList.add("hide");
                }

            }
            calculateFlyoutWidthAndHeight();
        };

        const calculateFlyoutWidthAndHeight = () => {
            const flyoutContainer = document.getElementById('flyOutNavigationSmall');
            const mainMenu = rootElem.value.querySelector(".main-menu");
            const toggle = document.querySelector(".page-header__panel-desktop");
            const toggleButton = toggle.querySelector('.page-header__toggle-desktop .hamburger');
            const items = [...mainMenu.children].filter(el => el.matches("li:not(.hide)"));
            const hamburgerText = toggle.querySelector('.page-header__toggle-desktop .hamburger--text');
            if (items.length !== 0){
                const lastItem = items[items.length - 1];
                const anchor = lastItem.querySelector("a");
                const width = anchor.getBoundingClientRect().width + hamburgerText.getBoundingClientRect().width + 89;
                flyoutContainer.style.width = width + "px";
            }
            if (flyoutContainer.style.height !== "0px" && ! toggle.classList.contains('hide') && toggleButton.classList.contains('is-active')) {
                flyoutContainer.style.height = flyoutContainer.scrollHeight + "px";
            }
            else {
                props.toggleDesktopNav(false);
            }
        }
        const initFlyoutMenuDesktop = (menu) => {
            const root = document.getElementById('website-doehler');
            for (const item of menu){
                item.addEventListener("click", e => {
                    e.preventDefault();
                    const id = item.dataset.flyid;

                    let mainMenuItem = rootElem.value.querySelector(
                        'a[data-id="' + id + '"]'
                    );
                    mainMenuItem.click();
                });
            }
        }
        const initMobileBackButtons = () => {
            document.querySelectorAll('a.mobile-backlink').forEach(backlink => {

                backlink.addEventListener("click", e => {
                    if (
                        breakpointState.value.cur === 'tablet_portrait' ||
                        breakpointState.value.cur === 'mobile'
                    ) {
                        e.preventDefault();
                        e.stopPropagation();
                        let currentMobileMenu = backlink.closest('.current-mobile-menu');
                        currentMobileMenu.classList.add('hide-mobile-right');
                        currentMobileMenu.classList.remove('current-mobile-menu');
                    }
                });
            });
        }

        function hashChanged() {
            const item = rootElem.value.querySelector('.clicked');
            if (item) {
                closeLayer(item);
            }
        }

        onMounted(() => {
            let menu = rootElem.value.querySelector(".main-menu");
            initMobileBackButtons();
            window.addEventListener("hashchange", hashChanged);

            if (!menu) {
                return;
            }

            let flyoutMenu = document.querySelector('.flyout-menu')
            const header = document.querySelector(".page-header__inner");
            const ro = ref(null);
            ro.value = new ResizeObserver(() => requestAnimationFrame(calculateVisibleMenuItems));
            ro.value.observe(header);
            initNavigationLayer(menu.children);
            initMobileNavigation(menu.children);
            initFlyoutMenuDesktop(flyoutMenu.children)
            window.addEventListener("resize", () => {
                calculateFlyoutWidthAndHeight()
            });

        });

        return {
            rootElem
        };
    },
};
</script>

<style lang="scss">

</style>
